import IconAsMaskImage from "app/components/IconAsMaskImage";

function MessageIcon({ pureSvg, className, color, ...rest }) {
  const svg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Group_4841"
      data-name="Group 4841"
      width="15.105"
      height="15.002"
      viewBox="0 0 15.105 15.002"
      {...rest}
    >
      <path
        id="Path_1827"
        data-name="Path 1827"
        d="M12.637,0H2.468A2.468,2.468,0,0,0,0,2.468V9.011A2.468,2.468,0,0,0,2.468,11.48h.77L2.217,13.9a.755.755,0,1,0,1.408.508l1.438-3.374a.193.193,0,0,1,0-.021v-.021l.015-.051a.437.437,0,0,1,.021-.079.74.74,0,0,0,0-.082.3.3,0,0,0,0-.051.743.743,0,0,0,0-.085v-.066a.631.631,0,0,0-.024-.069.272.272,0,0,0-.024-.069.387.387,0,0,0-.033-.06.468.468,0,0,0-.036-.066l-.048-.057a.369.369,0,0,0-.045-.051.42.42,0,0,0-.057-.045.272.272,0,0,0-.057-.045l-.057-.033a.622.622,0,0,0-.079-.036H4.586l-.073-.069H2.468a.958.958,0,0,1-.958-.958V2.468a.958.958,0,0,1,.958-.958H12.637a.958.958,0,0,1,.958.958V9.011a.958.958,0,0,1-.958.958H7.4a.755.755,0,0,0,0,1.51h5.235A2.468,2.468,0,0,0,15.1,9.011V2.468A2.468,2.468,0,0,0,12.637,0Z"
        fill="#fff"
      />
      <path
        id="Path_1828"
        data-name="Path 1828"
        d="M16.948,12.755A.755.755,0,0,0,16.193,12H10.755a.755.755,0,0,0,0,1.51h5.438A.755.755,0,0,0,16.948,12.755Z"
        transform="translate(-6.979 -8.375)"
        fill="#fff"
      />
      <rect
        id="Rectangle_2065"
        data-name="Rectangle 2065"
        width="3.21"
        height="1.605"
        rx="0.803"
        transform="translate(3.18 6.899)"
        fill="#fff"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default MessageIcon;
